import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Inner_Calm from "./inner_calm/Inner_Calm";
import Services from "./services/Services";
import Tapovan_Arpanam from "./tapovan_arpanam/Tapovan_Arpanam";
import Real_Wealth from "./real_wealth/Real_Wealth";
import Eternal_Elements from "./eternal_elements/Eternal_Elements";
import Anna_Seva from "./anna_seva/Anna_Seva";
import Chants from "./chants/Chants";
import Gurudevs_Shorts from "./gurudevs_shorts/Gurudevs_Shorts";
import Dose_Of_Peace from "./dose_of_peace/Dose_Of_Peace";
import Quote_of_day from "./quote-of-day/Quote_of_day";
import Testimonials from "./testimonials/Testimonials";
import { Offcanvas } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import Home_Notice_Offcanvas from "../common/offcanvas/home_notice_offcanvas/Home_Notice_Offcanvas";

function Home() {

  const [showOffCanvas, setShowOffCanvas] = useState(true);

  return (
    <>
      <Banner />
      <Quote_of_day />
      <Tapovan_Arpanam />
      <Inner_Calm />
      <Services />
      <Real_Wealth />
      <Eternal_Elements />
      <Anna_Seva />
      <Chants />
      <Gurudevs_Shorts />
      <Testimonials />
      <Dose_Of_Peace />

      {/* <Home_Notice_Offcanvas show={showOffCanvas} setShowOffCanvas={setShowOffCanvas}/> */}
    </>
  );
}

export default Home;
